<template>
  <div class="mainbox">
      <div class="item">
          <div>
              <van-icon name="idcard" />
              <span>非税单位编码</span>
          </div>
          <span>{{agencyCode}}</span>
      </div>
      <div class="item">
          <div>
              <van-icon name="user-circle-o" />
              <span>执收单位名称</span>
          </div>
          <span>{{unitName}}</span>
      </div>
      <div class="item">
          <div>
              <van-icon name="calender-o" />
              <span>业务生成日期</span>
          </div>
          <span>{{payDate}}</span>
      </div>
      <div class="payItem">
          <div class="title">
              <van-icon name="newspaper-o" />
              <span>收费项目</span>
          </div>
          <div class="items" v-for="(item,index) in itemDetails" :key="index">
              <div>处罚决定书号：{{bookNo}}</div>
              <div>
                  <div>
                      <div>项目名称</div>
                      <div>{{item.itemName}}</div>
                  </div>
                  <div>
                      <div>项目编号</div>
                      <div>{{item.itemCode}}</div>
                  </div>
                  <div>
                      <div>金额</div>
                      <div>{{item.amt/100}}元</div>
                  </div>
              </div>
          </div>
      </div>
    
      <div class="item">
          <div>
              <van-icon name="after-sale" />
              <span>缴纳金额</span>
          </div>
          <span class="colorRed">{{amount}}元</span>
      </div>

      <div class="payBtn" @click="getClientIp()">确认支付</div>

         <van-popup v-model="show" position="bottom" :style="{ height: '30%' }" >
             <van-picker
                title="支付方式"
                show-toolbar
                :columns="columns"
                @confirm="pay"
                @cancel="onCancel"
                visible-item-count='3'
                />
         </van-popup>
  </div>
</template>

<script>
// import { Picker } from 'vant';
export default {
        data(){
            return {
               show:false,
               agencyCode:'',
               unitName:'',
               payDate:'',
               bookNo:'',
               itemDetails:[],
               amount:'',
               merchantNo:'',
               widget_content:'',
               widget_data:'',
               thirdpayDomain:'',
               channelList:[],
               columns:[],
               path:'',
               url:''
            }
        },
        created(){
            this.getPayInfo();
        },
        methods:{
            getPayInfo(){
                    let data = {
                    payCode:this.$route.query.payCode,
                    payName:this.$route.query.payName,
                    widget_content:this.$route.query.widget_content,
                    amount:this.$route.query.amount,
                    deviceType:this.$route.query.deviceType
                }
                this.request({
                    baseURL: process.env.VUE_APP_PAY_URL,
                    url:'/tc_api/payInfo',
                    method:'post',
                    data:data
                }).then((res)=>{
                    if(res.data.code == 1000){
                        this.agencyCode = res.data.result.agencyCode;
                        this.unitName = res.data.result.unitName;
                        this.payDate = res.data.result.payDate;
                        this.bookNo = res.data.result.bookNo;
                        this.itemDetails = res.data.result.paramList.itemDetails
                        this.amount = res.data.result.amount;
                        this.merchantNo = res.data.result.merchant_no;
                        this.widget_content = res.data.result.widget_content;
                        this.widget_data = res.data.result.widget_data;
                        this.thirdpayDomain = res.data.result.thirdpayDomain;
                        this.url = res.data.result.thirdpayUrl;
                        this.payLoad()
                    }
                })
            },

            
            payLoad() {
                var dataAll=JSON.parse(this.widget_content);
                var merchant_no = dataAll.merchant_no;
                var deviceType = dataAll.device_type;
                var url = this.thirdpayDomain+"/thirdpay/widget/getConfigParam.do";
                var authCode = "";
                var widgetType = "";
                $.ajax({
                    url: url,
                    type: "post",
                    dataType: "json",
                    crossDomain: true,
                    cache: false,
                    data: {"merchantNo": merchant_no, "deviceType": deviceType, "widgetType": widgetType, "authCode": authCode},
                    success:(msg) => {
                        jQuery.support.cors = true;
                        var jsName = msg.js;
                        var channelList = msg.channelList;
                        this.path = this.thirdpaydomain + "/thirdpay/resources/widget/js/" + jsName;
                        this.widgetShow(dataAll,  channelList);
                    },
                    error: function (p1, p2, p3) {
                        alert(JSON.stringify(p1));
                    }
                });
            },
            widgetShow(data, channelList) {
                var flag = false;
                var num = 1;
                var loop = channelList.length;    //循环次数
                //用于区别是否为致新支付生单挂件
                for (var i = 0; i < loop; i++) {
                    if (channelList[i].fcode == "THIRDPAY_FSSD_H5") {
                        flag = true;
                        channelList.splice(i,1);
                        i = i - 1;    //改变循环变量
                        loop = loop - num;   //改变循环次数
                    }
                }
                this.channelList = JSON.parse(JSON.stringify(channelList))
                //查询支付渠道中包含招行非税渠道,有的话,拆分为招行微信与招行阿里
                // this.makeWidget(tmpList)
            },
          makeWidget(channelList) {
                var chanals = "";
                var ua = navigator.userAgent.toLowerCase();
                if(ua.match(/MicroMessenger/i) != "micromessenger"&&ua.indexOf("alipayclient") == -1){
                    var index=-1;
                    channelList.forEach(function(payChannel, i){
                        if (payChannel['fcode'] == 'WXPAYPUBLIC'
                            || payChannel['fcode'] == 'WXPAY_NONTAX_PUBLIC') {
                            index = i;
                        }
                    });
                    if(index != -1){
                        channelList.splice(index,1);
                    }
                }
                chanals+='<div  id="widdget_thirdpay_bosssoft_phone_new"> ';
                if(channelList.length >3){
                    channelList.slice(0, 3).forEach(function (payChannel) {
                        chanals+='    <div value="' + payChannel['fid'] + '" id="' + payChannel['fcode'] + '" data-code="'+payChannel['fcode']+'"  name="channel"  class="p_one_btn">';
                        chanals+='     <label class ="chal-pay" style="display:block;width:100%;">'+payChannel['fname']+'</label>';
                        chanals+='    </div>';
                    });
                    chanals += '<div id="more"  class=" more p_one_btn">';
                    chanals += '<label >更多..</label>';
                    chanals += '</div>';
                    channelList.slice(3).forEach(function (payChannel) {
                        chanals+='    <div value="' + payChannel['fid'] + '" id="' + payChannel['fcode'] + '" data-code="'+payChannel['fcode']+'" name="channel"  class="p_one_btn shows" >';
                        chanals+='     <label class="chal-pay" >'+payChannel['fname']+'</label>';
                        chanals+='    </div>';
                    });
                }else{
                    channelList.forEach(function (payChannel) {
                        chanals+='    <div value="' + payChannel['fid'] + '" id="' + payChannel['fcode'] + '" data-code="'+payChannel['fcode']+'" name="channel"  class="p_one_btn">';
                        chanals+='     <label class="chal-pay" style="display:block;width:100%;">'+payChannel['fname']+'</label>';
                        chanals+='    </div>';
                    });
                }
                chanals+='    </div>';
                
                $(".gua").append(chanals);
                console.log('结束',chanals)

         },
          getClientIp(callback, client_ip) {
	        $.ajax({
	            type:"get",
	            url:"https://mp.weixin.qq.com/intp/getuserclientip",
	            success:(data) =>{
                    this.client_ip = data.client_ip
                    this.goPay()
	            },
	            error:function (p1,p2,p3) {
	            }
	        });
	    },
         goPay() {
             this.columns = []
             var ua = navigator.userAgent.toLowerCase();
             if (ua.match(/MicroMessenger/i) == "micromessenger") {//微信浏览器
                  for(let i= this.channelList.length-1;i>=0;i--){
                    if(this.channelList[i].fcode == 'ALIPAY' || this.channelList[i].fcode == 'WXPAY_NONTAX_H5' || this.channelList[i].fcode == 'WXPAYPUBLIC' ){
                        this.channelList.splice(i,1);
                    }
                  }
                  if (this.channelList.length==1 && this.channelList[0].fcode == 'WXPAY_NONTAX_PUBLIC') {
                    //   直接调起微信支付
                      this.pay('','','wx')
                  }else {
                       this.handelColumns()
                       this.show = true
                  }
              } else if (ua.indexOf("alipay") != -1) {
                //支付宝浏览器
                 for(let i= this.channelList.length-1;i>=0;i--){
                    if(this.channelList[i].fcode == 'WXPAYPUBLIC' || this.channelList[i].fcode == 'WXPAY_NONTAX_PUBLIC' || this.channelList[i].fcode == 'WXPAY_NONTAX_H5' ){
                        this.channelList.splice(i,1);
                    }
                 }
                  if (this.channelList.length==1 &&  this.channelList[0].fcode == 'ALIPAY') {
                    //   直接调起支付宝支付
                      this.pay('','','zfb')
                  }else {
                       this.handelColumns()
                       this.show = true
                  }
              }else {
                   for(let i= this.channelList.length-1;i>=0;i--){
                        if(this.channelList[i].fcode == 'WXPAYPUBLIC' || this.channelList[i].fcode == 'WXPAY_NONTAX_PUBLIC' ){
                            this.channelList.splice(i,1);
                        }
                    }
                    this.handelColumns()
                    this.show = true
              }
         },
         handelColumns() {
              this.channelList.forEach((item,index)=> {
                  this.columns.push(item.fname)
              })
         },
         pay(val,index,type) {
             let channelcode = ''
             let channel = ''
             let url = this.url;
             if (type=='wx') {
                 channelcode = "WXPAY_NONTAX_PUBLIC"
                 channel = "989"
             }else if (type == 'zfb') {
                 channelcode = "ALIPAY"
                 channel = "993"
             }else {
                 channelcode = this.channelList[index].fcode
                 channel = this.channelList[index].fid
             }
            
            let widgetData = JSON.stringify(this.widget_data);
            $.ajax({
                 type: 'post',
                 url: url,
                 data: {
                    'channelcode':channelcode,
                    'channel': channel,
                    'merchantNo': this.merchantNo,
                    'widget_content': this.widget_content,
                    'widget_data': widgetData    
                 },
                 dataType: 'json',
                 success: function (result) {
                    if (result.success) {
                       document.write(result.extraInfo);
                    } else {
                       alert(result.msg);
                    }
                 }
            });



         },
         onCancel() {
             this.show = false
         }
        }
}
</script>


<style lang='scss' scoped>
    .mainbox {
        background: #f4f4f8;
        min-height: 100vh;
        box-sizing: border-box;
        padding: 20px 0 60px 0;
        color: #464A4C;
        .item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            padding: 0 15px;
            background: #fff;
            margin-bottom: 10px;
            height: 45px;
            font-size: 15px;
            >div {
                .van-icon {
                    color: #3B66A3;
                    font-size: 18px;
                    position: relative;
                    top: 4px;
                }
                span {
                    margin-left: 10px;
                }
            }
        }
        .payItem {
            margin-bottom: 10px;
            background: #fff;
            padding: 10px 15px;
            .title {
                font-size: 15px;
                .van-icon {
                    color: #3B66A3;
                    font-size: 18px;
                    position: relative;
                    top: 4px;
                }
                span {
                    margin-left: 10px;
                }
            }
            .items {
                margin-top: 15px;
                font-size: 15px;
                border-bottom: 1px solid #E4E4EA;
                >div:nth-of-type(1) {
                    margin-bottom: 15px;
                }
                >div:nth-of-type(2) {
                    padding-bottom: 5px;
                    >div {
                        height: 20px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 13px;
                        >div:nth-of-type(1) {
                            width: 60px;
                            text-align: justify;
                            vertical-align: top;
                            &::after {
                                display: inline-block;
                                width: 100%;
                                content: '';
                                height: 0;
                            }
                        }
                    }
                }
            }
        }

        .payBtn {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: #3B66A3;
            color: #fff;
            text-align: center;
            height: 50px;
            line-height: 50px;
            font-size: 16px;
        }
    }
    .colorRed {
        color: #FF2458;
    }

    .shows{
            display:none;
        }

        #widget .p_one_btn{
            font-size: 0.28rem;
            padding:0.1rem 0px!important;
        }
        div.zhe{
            width: 100%;
            height: 150px;
            background: white;
            position: absolute;
            z-index: 3;
            top:-200px;
            box-shadow:0px 0px 4px 5px #AAAAAA;
        }
        div.zhew{
            position: absolute;
            top: 0;
            left: 0;
            background-color: rgba(169,169,169,0.8);
            width: 100%;
            height: 100%;
            z-index: 2;
            display: none;
        }
        div.gua{
            width: 100%;
            background: white;
            position: absolute;
            z-index: 3;
            bottom:-200px;
            box-shadow:0px 0px 4px 5px #AAAAAA;
        }
</style>